module.exports = __webpack_public_path__ + "img/slide-3.511e9425.jpg";